module.exports = __webpack_public_path__ + "static/media/bg_banner_indique_amigo.41849736.jpg";